/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from 'zod/v4'

export const putUsersPreferencesUnitsUnitidPathUnitIdSchema = z.string()

export const putUsersPreferencesUnitsUnitidStatus200Schema = z.object({
  id: z.string().describe('Unique identifier').meta({ examples: [1] }),
  type: z.enum(['area', 'density', 'diameter', 'differentialPressure', 'electricalPower', 'energy', 'flow', 'force', 'heatTransfer', 'kinematicViscosity', 'kvCvCoefficient', 'length', 'linearPressureDrop', 'mass', 'roughness', 'specificHeat', 'staticPressure', 'temperature', 'temperatureDifference', 'thermalConductivity', 'thermalPower', 'thickness', 'torque', 'velocity', 'volume', 'waterHardness']).describe('The type of the unit').meta({ examples: ['length'] }),
  value: z.string().describe('The preferred unit of the user for the given type').meta({ examples: ['_U_LENGTH_CM'] }),
})

export const putUsersPreferencesUnitsUnitidStatus400Schema = z.string()

export const putUsersPreferencesUnitsUnitidStatus401Schema = z.string()

export const putUsersPreferencesUnitsUnitidStatus404Schema = z.string()

export const putUsersPreferencesUnitsUnitidStatus500Schema = z.string()

export const putUsersPreferencesUnitsUnitidResponseSchema = putUsersPreferencesUnitsUnitidStatus200Schema

export const putUsersPreferencesUnitsUnitidErrorSchema = z.union([putUsersPreferencesUnitsUnitidStatus400Schema, putUsersPreferencesUnitsUnitidStatus401Schema, putUsersPreferencesUnitsUnitidStatus404Schema, putUsersPreferencesUnitsUnitidStatus500Schema])

export const putUsersPreferencesUnitsUnitidBodySchema = z.object({
  type: z.enum(['area', 'density', 'diameter', 'differentialPressure', 'electricalPower', 'energy', 'flow', 'force', 'heatTransfer', 'kinematicViscosity', 'kvCvCoefficient', 'length', 'linearPressureDrop', 'mass', 'roughness', 'specificHeat', 'staticPressure', 'temperature', 'temperatureDifference', 'thermalConductivity', 'thermalPower', 'thickness', 'torque', 'velocity', 'volume', 'waterHardness']).describe('The type of the unit').meta({ examples: ['length'] }),
  value: z.string().describe('The preferred unit of the user for the given type').meta({ examples: ['_U_LENGTH_CM'] }),
}).optional()

export const putUsersPreferencesUnitsUnitidPathSchema = z.object({
  unitId: z.string(),
})
